import { CardType, TagsFilters } from '../models/tags';

export const tagsQueries = {
  all: (type: CardType) => [type, 'tags'] as const,
  list: (type: CardType, filters: TagsFilters) => [...tagsQueries.all(type), filters],
  infinityList: (type: CardType, filters: TagsFilters) => [
    ...tagsQueries.all(type),
    'infinity',
    filters,
  ],
  detail: (type: CardType, id: string) => [...tagsQueries.all(type), 'detail', id],
  assigned: (type: CardType, cardId: string) => [...tagsQueries.all(type), 'assigned', { cardId }],
};

export const tagsMutationKeys = {
  assignTags: ['assign-tags'],
};
